import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {
  FilterDTO,
  PagedResultDTOOfProblemReportResponseDTO,
  ProblemReportClient,
  SortDirection,
} from '../../../base/models/models.swagger.generated';
import { IAdaptorService } from '../../../base/shared/syncfusion/adaptor-service.interface';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from '../../../core/routing/error-types';

@Injectable()
export class ProblemReportAdministrationService extends ShowInactiveService implements IAdaptorService {

  public numTotalRecordsFound = 0;

  constructor(
    private problemReportClient: ProblemReportClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfProblemReportResponseDTO> {
    if (!sortBy) {
      sortBy = 'CreatedOn';
      sortDirection = SortDirection.Descending;
    }
    return this.problemReportClient.searchProblemReports(filters, skip, take, sortBy, sortDirection).pipe(
      tap((result) => {
        this.numTotalRecordsFound = result?.totalNumberOfItems ?? 0;
      })
    );
  }

  public addRecord(_data: any): Observable<any> {
    return of(null);
  }

  public updateRecord(_data: any): Observable<any> {
    return of(null);
  }

  public deleteRecord(id: number): Observable<void> {
    return this.problemReportClient.deleteProblemReport(id).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.problem-report-administration.messages.delete-title',
          'i18n.domain.problem-report-administration.messages.delete-success-message'
        );
      }),
      catchError(error => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
